import { act } from "react-dom/test-utils"
import {
  GET_PROJECTS_VISITS_SUCCESS,
  GET_PROJECTS_MONITORIZATIONS_SUCCESS,
  GET_PROJECTS_CENTERS_SUCCESS,
  CLOSE_MODAL,
  GET_CENTERS_DEVICES_SUCCESS,
  GET_CENTERS_PAYMENTS_SUCCESS,
  GET_CENTERS_PAYMENTS_FLOW,
  GET_CENTERS_PAYMENTS_FLOW_SUCCESS,
  GET_CENTERS_PAYMENTS_FLOW_THEME,
  GET_CENTERS_PAYMENTS_FLOW_THEME_SUCCESS,
  NEW_PROFORMA,
  NEW_PROFORMA_SUCCESS,
  NEW_PAY_FLOW,
  NEW_PAY_FLOW_SUCCESS,
  SET_PROFORMA_THEME,
  SET_PROFORMA_THEME_SUCCESS,
  SET_PROFORMA_DATA,
  DELETE_PROJECTS_PROFORMA_DATA,
  SET_PROFORMA_DATA_SUCCESS,
  SET_PROFORMA_THEME_STATUS_CHANGE,
  RESET_PROFORMA_THEME,


} from "./actionTypes"

const INIT_STATE = {
  projects_visits: {},
  projects_monitorizations: {},
  projects_centers: {},
  centers_devices: {},
  centers_payments: {},
  payment_flows: {},
  payment_theme_flows: {},
  proformas: {},
  saved_proforma_theme: {},
  flow_status: {},
  saved_proforma: {},
  saved_proforma_status: {},
  close_modal: false,
}

const contacts = (state = INIT_STATE, action) => {
  let new_state = { ...state }

  switch (action.type) {
    case "RESET_PROFORMA_THEME":
            return {
                ...state,
                saved_proforma_theme: {},
            };
    case SET_PROFORMA_THEME_STATUS_CHANGE:
      console.log("SET_PROFORMA_THEME_STATUS_CHANGE", action.payload)
      new_state.saved_proforma_theme.status = action.payload.status
      return new_state
    case GET_CENTERS_PAYMENTS_FLOW_SUCCESS:
      // console.log(action.payload);
      return {
        ...state,
        payment_flows: action.payload.payment_flows,
      }

    case GET_CENTERS_PAYMENTS_FLOW_THEME_SUCCESS:
      new_state.payment_theme_flows = action.payload.payment_theme_flows
      return new_state

    case NEW_PAY_FLOW_SUCCESS:
      new_state.flow_status = action.payload.payment_flows
      return new_state
    case SET_PROFORMA_THEME_SUCCESS:
      console.log("SET_PROFORMA_THEME_SUCCESS", action.payload.response)
      new_state.saved_proforma_theme = action.payload.response
      console.log(new_state);
      return new_state
    case SET_PROFORMA_DATA_SUCCESS:
      console.log("SET_PROFORMA_DATA_SUCCESS", action.payload.response)
      return new_state
    case NEW_PROFORMA_SUCCESS:
      console.log("NEW_PROFORMA_SUCCESS", action.payload.response)
      new_state.saved_proforma = action.payload.response.saved_data
      new_state.saved_proforma_status = action.payload.response.status
      return new_state

    case GET_PROJECTS_VISITS_SUCCESS:
      let new_projects_visits = { ...new_state.projects_visits }
      new_projects_visits[action.payload.project_id] = action.payload.visit
      new_state.projects_visits = new_projects_visits
      return new_state

    case GET_PROJECTS_MONITORIZATIONS_SUCCESS:
      let new_projects_monitorizations = { ...new_state.projects_monitorizations }
      new_projects_monitorizations[action.payload.project_id] = action.payload.monitorization
      new_state.projects_monitorizations = new_projects_monitorizations
      return new_state

    case GET_PROJECTS_CENTERS_SUCCESS:
      let new_projects_centers = { ...new_state.projects_centers }
      new_projects_centers[action.payload.project_id] = action.payload.center
      new_state.projects_centers = new_projects_centers
      return new_state

    case GET_CENTERS_DEVICES_SUCCESS:
      let new_centers_devices = { ...new_state.centers_devices }
      new_centers_devices[action.payload.center_id] = action.payload.devices
      new_state.centers_devices = new_centers_devices
      return new_state

    case GET_CENTERS_PAYMENTS_SUCCESS:
      let new_centers_payments = { ...new_state.centers_payments }
      new_centers_payments[action.payload.center_id] = action.payload.payments
      new_state.centers_payments = new_centers_payments
      new_state.payment_theme_flows={}
      return new_state

    case CLOSE_MODAL:
      return { ...state, close_modal: action.payload.close }

    default:
      return state
  }
}

export default contacts
